module.exports = __webpack_public_path__ + "img/italyan domatesli.8dfbfd8a.png";